export default "__VITE_ASSET__5be0090d__"